import { get } from 'lodash';
import { fork, take, call, put } from 'redux-saga/effects';

import {
	TRANSACTION_LIST_ERROR,
	TRANSACTION_LIST_REQUESTING,
	TRANSACTION_LIST_SUCCESS,
	SET_OPTIONAL_FIELD,
} from '@/redux/ducks/transaction/types';
import { INIT_APP_ERROR } from '@/redux/ducks/init/types';
import Api from '@/data';
import { SHOW_TOAST } from '@/redux/ducks/toast/types';

export function* fetchTransactions(payload) {
	try {
		const payloadToSend = payload;
		const response = yield call(Api.getTransactionListNew, payloadToSend);
		const successData = {
			...response.data,
			currentPage: payloadToSend.offset / payloadToSend.size + 1,
		};
		yield put({ type: TRANSACTION_LIST_SUCCESS, data: successData });
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: TRANSACTION_LIST_ERROR, error: error.data });
			yield put({
				type: SHOW_TOAST,
				payload: { msg: get(error, 'data.message'), type: 'error' },
			});
		}
	}
}

export function* getTransactions() {
	while (true) {
		const payload = yield take(TRANSACTION_LIST_REQUESTING);
		yield call(fetchTransactions, payload.payload);
	}
}

export function* forkSetOptionalField() {
	while (true) {
		yield take(SET_OPTIONAL_FIELD);
	}
}

function* transactionFlowSaga() {
	yield fork(getTransactions);
	yield fork(forkSetOptionalField);
}

export default transactionFlowSaga;
